import React, { useState, useEffect } from "react";
import {
  Grid,
  LinearProgress,
  Select,
  OutlinedInput,
  MenuItem,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import {
  ResponsiveContainer,
  ComposedChart,
  AreaChart,
  LineChart,
  Line,
  Area,
  PieChart,
  Pie,
  Cell,
  CartesianGrid, 
  ScatterChart, Scatter, 
  YAxis,
  XAxis,
} from "recharts";

// styles
import useStyles from "./styles";

//date picker
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import firebase from "../../firebase.js"

// components
import mock from "./mock";
import Widget from "../../components/Widget";
import PageTitle from "../../components/PageTitle";
import { Typography } from "../../components/Wrappers";
import Dot from "../../components/Sidebar/components/Dot";
import Table from "./components/Table/Table";
import SummaryTable from "./components/Table/SummaryTable.js";
import BigStat from "./components/BigStat/BigStat";
import { TrendingUpOutlined, TrendingFlat, VerticalAlignBottom } from "@material-ui/icons";

var database = firebase.database();
const mainChartData = getMainChartData();
const PieChartData = [
  { name: "Production", value: 400, color: "primary" },
  { name: "Mechatronics", value: 300, color: "secondary" },
  { name: "Quality", value: 300, color: "warning" },
  { name: "Logistics", value: 200, color: "success" },
];

const PieChartData2 = [
  { name: "Production", value: 100, color: "primary" },
  { name: "Mechatronics", value: 200, color: "secondary" },
  { name: "Quality", value: 300, color: "warning" },
  { name: "Logistics", value: 400, color: "success" },
];

function createDefectData(Category, Date, DefectName,SubCategory, Observation, DetectedAt, Model, EngineNumber, OperatorCode, Status, Shift, Zone, Station, DefectGenerationTime, Remarks, Id) {
  return { Category, Date, DefectName,SubCategory, Observation, DetectedAt, Model, EngineNumber, OperatorCode, Status, Shift, Zone, Station, DefectGenerationTime, Remarks, Id};
}

function createLossSummaryData(category, description, loss, colour) {
  return { category, description, loss, colour};
}

function createLossPieChartData(name, value, color) {
  return { name, value, color};
}

function createOfftrackData(EngineNumber, Model, Timestamp) {
  return { EngineNumber, Model, Timestamp};
}

function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) 
      month = '0' + month;
  if (day.length < 2) 
      day = '0' + day;

  return [year, month, day].join('-');
}

export default function Dashboard(props) {
  var classes = useStyles();
  var theme = useTheme();

  var defectArray = [];
  var colourArray=["g1","g2","g3","g4","g5","g6","g7","g8","g9","g10","g11","g12","g13","g14","g15"];
  var lossSummaryData=[];
  var lossPieChartData=[];
  var defectPieChartData=[];
  var modelPieChartData=[];
  var resultArray = [0];
  var idealArray=[];
  var offtrack=0;
  var rework=[];
  var rejection=0;
  var laydown=0;
  // local
  var [shiftState, setShiftState] = useState("DS");

  var [lineState, setLineState] = useState("B");

  var [lossPieChartState, setLossPieChartState] = useState(lossPieChartData);
  var [defectPieChartState, setDefectPieChartState] = useState(defectPieChartData);
  var [modelPieChartState, setModelPieChartState] = useState(modelPieChartData);
  var [defectState, setDefectState] = useState(defectArray);
  var [mainChartDataState, setMainChartDataState] = useState(resultArray);
  var [summaryDataState, setSummaryDataState] = useState(lossSummaryData);
  var [offtrackDataState, setOfftrackDataState] = useState(offtrack);
  var [laydownDataState, setLaydownDataState] = useState(laydown);
  var [rejectionDataState, setRejectionDataState] = useState(rejection);
  var [reworkDataState, setReworkDataState] = useState(rework);
  const defaultDate = new Date('2020-12-18');
  const [selectedDate, setSelectedDate] = React.useState(defaultDate);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };
  
  useEffect(() => {

    //read line cycle time here 

    var ref = database.ref('ENS5/zone/'+lineState+'/Defect Data/'+formatDate(selectedDate)+'/'+shiftState);
    console.log('ENS5/zone/'+lineState+'/Defect Data');
      ref.on('value', function(snapshot) {
      var rework=[];
      defectArray = [];
      var categoryArray = [];
      var defectCountArray = [];
      snapshot.forEach(function(childSnapshot) {
      var defectCategory = childSnapshot.child("Category").val();
      var Date = childSnapshot.child("Date").val();
      var DefectName= childSnapshot.child("Defect Name").val();
      var SubCategory= childSnapshot.child("Subcategory").val();
      var Observation= childSnapshot.child("Observation").val();
      var Zone= childSnapshot.child("Zone").val();
      var Remarks= childSnapshot.child("AddRemarks").val();
      var DetectedAt= childSnapshot.child("Detected At").val();
      var Model= childSnapshot.child("Engine Model").val();
      var EngineNumber= childSnapshot.child("Engine Number").val();
      var OperatorCode= childSnapshot.child("Operator Code").val();
      var Status=  childSnapshot.child("Rectification Status").val();
      var Shift= childSnapshot.child("Shift").val();
      var Station= childSnapshot.child("Station").val();
      var DefectGenerationTime= childSnapshot.child("Timestamp").val();
      var Id= childSnapshot.key;

      if(rework.indexOf(EngineNumber)===-1&&Status==="RECTIFIED")
            rework.push(EngineNumber);
      if(categoryArray.indexOf(defectCategory)===-1)
      categoryArray.push(defectCategory);
      defectArray.push(createDefectData(defectCategory, Date, DefectName, SubCategory, Observation, DetectedAt, Model, EngineNumber, OperatorCode, Status, Shift, Zone, Station, DefectGenerationTime, Remarks, Id));
      
      if(defectCountArray[categoryArray.indexOf(defectCategory)])
      defectCountArray[categoryArray.indexOf(defectCategory)] += 1;
      else
      defectCountArray[categoryArray.indexOf(defectCategory)] = 1;
      });

      defectPieChartData=[];
       for(var i=0;i<categoryArray.length; i++){
        defectPieChartData.push(createLossPieChartData(categoryArray[i], defectCountArray[i], colourArray[i]));
        }
       setDefectState(defectState=>defectArray);
       setDefectPieChartState(defectPieChartState=>defectPieChartData);
       setReworkDataState(reworkDataState=>rework);
    });

    var ref2 = database.ref('ENS5/zone/'+lineState+'/indexData/'+formatDate(selectedDate)+'/'+shiftState);
    console.log('ENS5/zone/'+lineState+'/indexData/'+formatDate(selectedDate)+'/'+shiftState);
      ref2.on('value', function(snapshot) {
      var ideal = [];
      var actual = [];
      var lossArray = [];
      var categoryArray = [];
      var reasonArray = [];
      var lossSum = 0;
      var lossData = {};
      ideal.push(Number(0));
      actual.push(Number(0));
      snapshot.forEach(function(childSnapshot) {
        var childKey = Number(childSnapshot.key);
        var category = childSnapshot.child("category").val();
        var loss = Number(childSnapshot.child("delay").val())/234; //needs to be changed
        console.log(loss);
        lossSum+=loss;
        var reason = childSnapshot.child("reason").val();
        ideal.push(Number(childKey));
        actual.push(Number(childKey+lossSum));
        console.log(categoryArray.indexOf(category));
        if(categoryArray.indexOf(category)===-1)
        categoryArray.push(category);
        // Ensure the category exists in the lossData object
        if (!lossData[category]) {
        lossData[category] = {};
        }
        // Aggregate loss within each reason for the current category
        if (lossData[category][reason]) {
        lossData[category][reason] += loss;
        } else {
        lossData[category][reason] = loss;
        }
        
        if(lossArray[categoryArray.indexOf(category)])
        lossArray[categoryArray.indexOf(category)] += loss;
        else
        lossArray[categoryArray.indexOf(category)] = loss;
        //newIndexArray.push(childData);
      });
      
      Object.keys(lossData).forEach(category => {
        var reasons = Object.keys(lossData[category]);
      
        reasons.forEach(reason => {
          var aggregatedLoss = lossData[category][reason];
      
          if (aggregatedLoss > 0.5) {
            if (reasonArray[categoryArray.indexOf(category)]) {
              reasonArray[categoryArray.indexOf(category)] += `${reason}(${aggregatedLoss.toFixed(2)})\n`;
            } else {
              reasonArray[categoryArray.indexOf(category)] = `${reason}(${aggregatedLoss.toFixed(2)})\n`;
            }
          }
        });
      });
      
    console.log(lossArray);
    console.log(reasonArray);
    console.log(defectArray);
    console.log(ideal);
    console.log(actual);
    lossPieChartData=[];
    resultArray=[];
    lossSummaryData=[];
    for(var i=0;i<categoryArray.length; i++){
    lossSummaryData.push(createLossSummaryData(categoryArray[i], reasonArray[i], Number(lossArray[i].toFixed(2)), colourArray[i]));
    lossPieChartData.push(createLossPieChartData(categoryArray[i], Number(lossArray[i].toFixed(2)), colourArray[i]));
    }
    for (let i = 0; i < ideal.length; i++) {
      resultArray.push({
        y: ideal[i],
        x: actual[i]
      });
    }
    setMainChartDataState(mainChartDataState=>resultArray);
    setLossPieChartState(lossPieChartState=>lossPieChartData);
    setSummaryDataState(summaryDataState=>lossSummaryData);
    console.log(lossPieChartData);
    console.log(resultArray);
  });

  var ref3 = database.ref('ENS5/zone/'+lineState+'/Offtrack/'+formatDate(selectedDate)+'/'+shiftState);
  console.log('ENS5/zone/'+lineState+'/Offtrack/'+formatDate(selectedDate)+'/'+shiftState);
    ref3.on('value', function(snapshot) {
      offtrack=0;
      modelPieChartData=[];
      var modelArray = [];
      var modelCountArray = [];
      snapshot.forEach(function(childSnapshot) {
        offtrack+=1;
        var model = childSnapshot.child("Model").val();
        if(modelArray.indexOf(model)===-1)
        modelArray.push(model);
        if(modelCountArray[modelArray.indexOf(model)])
        modelCountArray[modelArray.indexOf(model)] += 1;
        else
        modelCountArray[modelArray.indexOf(model)] = 1;

        //modelArray.push(createOfftrackData(childSnapshot.child("Engine Number").val(), childSnapshot.child("Model").val(), childSnapshot.child("Timestamp").val()))
      });
      for(var i=0;i<modelArray.length;i++)
      modelPieChartData.push(createLossPieChartData(modelArray[i], modelCountArray[i], colourArray[i]));
      setModelPieChartState(modelPieChartState=>modelPieChartData);
      setOfftrackDataState(offtrackDataState=>offtrack);
  });

  var ref4 = database.ref('ENS5/zone/'+lineState+'/Laydown/'+formatDate(selectedDate)+'/'+shiftState);
  console.log('ENS5/zone/'+lineState+'/Laydown/'+formatDate(selectedDate)+'/'+shiftState);
    ref4.on('value', function(snapshot) {
      laydown=0;
      snapshot.forEach(function(childSnapshot) {
        laydown+=1;
      });
      setLaydownDataState(laydownDataState=>laydown);
  });

  var ref5 = database.ref('ENS5/zone/'+lineState+'/Rejection/'+formatDate(selectedDate)+'/'+shiftState);
  console.log('ENS5/zone/'+lineState+'/Rejection/'+formatDate(selectedDate)+'/'+shiftState);
    ref5.on('value', function(snapshot) {
      rejection=0;
      snapshot.forEach(function(childSnapshot) {
        rejection+=1;
      });
      setRejectionDataState(rejectionDataState=>rejection);
  });

  return() => {
    ref.off();
    ref2.off();
    ref3.off();
    ref4.off();
    ref5.off();
    }

  }, [lineState, shiftState, selectedDate])

  return (
    <>
      <PageTitle title="Production summary report" button="Print"/>
      <Grid align="center" alignItems="center" container spacing={4}>
        <Grid item lg={4} md={6} sm={6} xs={4}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <KeyboardDatePicker
          margin="normal"
          id="date-picker-dialog"
          label="Select Date"
          format="yyyy-MM-dd"
          value={selectedDate}
          onChange={handleDateChange}
          KeyboardButtonProps={{
            'aria-label': 'change date',
          }}
        />
        </MuiPickersUtilsProvider>
        </Grid>
        <Grid item lg={4} md={6} sm={6} xs={4}>
        <Select
                  value={shiftState}
                  onChange={e => setShiftState(shiftState=>e.target.value)}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                      classes={{
                        notchedOutline: classes.mainChartSelectRoot,
                        input: classes.mainChartSelect,
                      }}
                    />
                  }
                  autoWidth
                >
                  <MenuItem value="DS">Day Shift</MenuItem>
                  <MenuItem value="NS">Night Shift</MenuItem>
                  <MenuItem value="FS">First Shift</MenuItem>
                </Select>
                </Grid>
                <Grid item lg={4} md={6} sm={6} xs={4}>
        <Select
                  value={lineState}
                  onChange={e => setLineState(e.target.value)}
                  input={
                    <OutlinedInput
                      labelWidth={0}
                      classes={{
                        notchedOutline: classes.mainChartSelectRoot,
                        input: classes.mainChartSelect,
                      }}
                    />
                  }
                  autoWidth
                >
                  <MenuItem value="B">B zone</MenuItem>
                  <MenuItem value="C">C zone</MenuItem>
                  <MenuItem value="TESTING">Testing</MenuItem>
                  <MenuItem value="DRESSING">Dressing</MenuItem>
                  <MenuItem value="RECTIFICATION">Rectification</MenuItem>
                </Select>
                </Grid>
        </Grid>
      <Grid container spacing={4}>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget
            title="Output summary"
            upperTitle
            bodyClass={classes.fullHeightBody}
            className={classes.card}
          >
            
            <div className={classes.visitsNumberContainer}>
              
              <Typography size="xxl" weight="medium">
                {offtrackDataState}
              </Typography>
              <LineChart
                width={55}
                height={30}
                data={[
                  { value: 10 },
                  { value: 15 },
                  { value: 10 },
                  { value: 17 },
                  { value: 18 },
                ]}
                margin={{ left: theme.spacing(2) }}
              >
                <Line
                  type="natural"
                  dataKey="value"
                  stroke={theme.palette.success.main}
                  strokeWidth={2}
                  dot={false}
                />
              </LineChart>
            </div>
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              <Grid item>
                <Typography color="text" colorBrightness="secondary">
                  Rejection
                </Typography>
                <Typography size="md">{rejectionDataState}</Typography>
              </Grid>
              <Grid item>
                <Typography color="text" colorBrightness="secondary">
                  Total
                </Typography>
                <Typography size="md">{offtrackDataState+rejectionDataState}</Typography>
              </Grid>
              <Grid item>
                <Typography color="text" colorBrightness="secondary">
                  Straight Pass
                </Typography>
                <Typography size="md">{(((offtrackDataState-reworkDataState.length)/(offtrackDataState+rejectionDataState))*100).toFixed(2)}</Typography>
              </Grid>
            </Grid>
          </Widget>
        </Grid>
        {/*
        <Grid item lg={3} md={8} sm={6} xs={12}>
          <Widget
            title="App Performance"
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.performanceLegendWrapper}>
              <div className={classes.legendElement}>
                <Dot color="warning" />
                <Typography
                  color="text"
                  colorBrightness="secondary"
                  className={classes.legendElementText}
                >
                  Integration
                </Typography>
              </div>
              <div className={classes.legendElement}>
                <Dot color="primary" />
                <Typography
                  color="text"
                  colorBrightness="secondary"
                  className={classes.legendElementText}
                >
                  SDK
                </Typography>
              </div>
            </div>
            <div className={classes.progressSection}>
              <Typography
                size="md"
                color="text"
                colorBrightness="secondary"
                className={classes.progressSectionTitle}
              >
                Integration
              </Typography>
              <LinearProgress
                variant="determinate"
                value={30}
                classes={{ barColorPrimary: classes.progressBar }}
                className={classes.progress}
              />
            </div>
            <div>
              <Typography
                size="md"
                color="text"
                colorBrightness="secondary"
                className={classes.progressSectionTitle}
              >
                SDK
              </Typography>
              <LinearProgress
                variant="determinate"
                value={55}
                classes={{ barColorPrimary: classes.progressBar }}
                className={classes.progress}
              />
            </div>
          </Widget>
        </Grid>
        *
        <Grid item lg={4} md={6} sm={6} xs={16}>
          <Widget
            title="Server Overview"
            upperTitle
            className={classes.card}
            bodyClass={classes.fullHeightBody}
          >
            <div className={classes.serverOverviewElement}>
              <Typography
                color="text"
                colorBrightness="secondary"
                className={classes.serverOverviewElementText}
              >
                60% / 37°С / 3.3 Ghz
              </Typography>
              <div className={classes.serverOverviewElementChartWrapper}>
                <ResponsiveContainer height={50} width="99%">
                  <AreaChart data={getRandomData(10)}>
                    <Area
                      type="natural"
                      dataKey="value"
                      stroke={theme.palette.secondary.main}
                      fill={theme.palette.secondary.light}
                      strokeWidth={2}
                      fillOpacity="0.25"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={classes.serverOverviewElement}>
              <Typography
                color="text"
                colorBrightness="secondary"
                className={classes.serverOverviewElementText}
              >
                54% / 31°С / 3.3 Ghz
              </Typography>
              <div className={classes.serverOverviewElementChartWrapper}>
                <ResponsiveContainer height={50} width="99%">
                  <AreaChart data={getRandomData(10)}>
                    <Area
                      type="natural"
                      dataKey="value"
                      stroke={theme.palette.primary.main}
                      fill={theme.palette.primary.light}
                      strokeWidth={2}
                      fillOpacity="0.25"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div className={classes.serverOverviewElement}>
              <Typography
                color="text"
                colorBrightness="secondary"
                className={classes.serverOverviewElementText}
              >
                57% / 21°С / 3.3 Ghz
              </Typography>
              <div className={classes.serverOverviewElementChartWrapper}>
                <ResponsiveContainer height={50} width="99%">
                  <AreaChart data={getRandomData(10)}>
                    <Area
                      type="natural"
                      dataKey="value"
                      stroke={theme.palette.warning.main}
                      fill={theme.palette.warning.light}
                      strokeWidth={2}
                      fillOpacity="0.25"
                    />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </div>
          </Widget>
        </Grid>*/}
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget title="Defect overview" upperTitle className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ResponsiveContainer width="100%" height={144}>
                  <PieChart margin={{ left: theme.spacing(2) }}>
                    <Pie
                      data={defectPieChartState}
                      innerRadius={45}
                      outerRadius={60}
                      dataKey="value"
                    >
                      {defectPieChartState.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={theme.palette[entry.color].main}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </Grid>
              <Grid item xs={6}>
                <div className={classes.pieChartLegendWrapper}>
                  {defectPieChartState.map(({ name, value, color }, index) => (
                    <div key={color} className={classes.legendItemContainer}>
                      <Dot color={color} />
                      <Typography style={{ whiteSpace: "nowrap" }}>
                        &nbsp;{name}&nbsp;
                      </Typography>
                      <Typography color="text" colorBrightness="secondary">
                        &nbsp;{value}
                      </Typography>
                    </div>
                  ))}
                </div>
              </Grid>
            </Grid>
          </Widget>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget title="Model overview" upperTitle className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ResponsiveContainer width="100%" height={144}>
                  <PieChart margin={{ left: theme.spacing(2) }}>
                    <Pie
                      data={modelPieChartState}
                      innerRadius={45}
                      outerRadius={60}
                      dataKey="value"
                    >
                      {modelPieChartState.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={theme.palette[entry.color].main}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </Grid>
              <Grid item xs={6}>
                <div className={classes.pieChartLegendWrapper}>
                  {modelPieChartState.map(({ name, value, color }, index) => (
                    <div key={color} className={classes.legendItemContainer}>
                      <Dot color={color} />
                      <Typography style={{ whiteSpace: "nowrap" }}>
                        &nbsp;{name}&nbsp;
                      </Typography>
                      <Typography color="text" colorBrightness="secondary">
                        &nbsp;{value}
                      </Typography>
                    </div>
                  ))}
                </div>
              </Grid>
            </Grid>
          </Widget>
        </Grid>
        <Grid item lg={6} md={6} sm={6} xs={12}>
          <Widget title="Loss overview" upperTitle className={classes.card}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <ResponsiveContainer width="100%" height={144}>
                  <PieChart margin={{ left: theme.spacing(2) }}>
                    <Pie
                      data={lossPieChartState}
                      innerRadius={45}
                      outerRadius={60}
                      dataKey="value"
                    >
                      {lossPieChartState.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={theme.palette[entry.color].main}
                        />
                      ))}
                    </Pie>
                  </PieChart>
                </ResponsiveContainer>
              </Grid>
              <Grid item xs={6}>
                <div className={classes.pieChartLegendWrapper}>
                  {lossPieChartState.map(({ name, value, color }, index) => (
                    <div key={color} className={classes.legendItemContainer}>
                      <Dot color={color} />
                      <Typography style={{ whiteSpace: "nowrap" }}>
                        &nbsp;{name}&nbsp;
                      </Typography>
                      <Typography color="text" colorBrightness="secondary">
                        &nbsp;{value}
                      </Typography>
                    </div>
                  ))}
                </div>
              </Grid>
            </Grid>
          </Widget>
        </Grid>
        <Grid item xs={12}>
          <Widget
            bodyClass={classes.mainChartBody}
            header={
              <div className={classes.mainChartHeader}>
                <Typography
                  variant="h5"
                  color="text"
                  colorBrightness="secondary"
                  
                >
                  Daily Line Chart
                </Typography>
                <div align="center" className={classes.mainChartHeaderLabels}>
                  <div className={classes.mainChartHeaderLabel}>
                    <Dot color="warning" />
                    <Typography className={classes.mainChartLegentElement}>
                    Ideal
                    </Typography>
                  </div>
                  <div className={classes.mainChartHeaderLabel}>
                    <Dot color="primary" />
                    <Typography className={classes.mainChartLegentElement}>
                      Actual
                    </Typography>
                  </div>
                  
                  {/*<div className={classes.mainChartHeaderLabel}>
                    <Dot color="primary" />
                    <Typography className={classes.mainChartLegentElement}>
                      Desktop
                    </Typography>
            </div>*/}
                </div>
                {/*menu was here*/}
                
              </div>
            }
          >
            <ResponsiveContainer width="100%" minWidth={500} height={350}>
              <ComposedChart    
                margin={{ top: 0, right: -15, left: -15, bottom: 0 }}
                data={mainChartDataState}

              >
                <CartesianGrid />
                 <XAxis 
                  type="number" dataKey="x"
                  tickFormatter={i => i + 1}
                  tick={{ fill: theme.palette.text.hint + "80", fontSize: 14 }}
                   stroke={theme.palette.text.hint + "80"}
                   tickLine={false}
                  />
                <YAxis           
                  type="number" dataKey="y"
                  ticks={[40,80,120]}
                  tick={{ fill: theme.palette.text.hint + "80", fontSize: 14 }}
                  stroke={theme.palette.text.hint + "80"}
                  tickLine={false}

                />
                
                {/*<Area
                  type="natural"
                  dataKey="desktop"
                  fill={theme.palette.background.light}
                  strokeWidth={0}
                  activeDot={false}
                />*/}
                {/*<Line
                  type="natural"
                  dataKey="actual"
                  stroke={theme.palette.primary.main}
                  strokeWidth={2}
                  dot={false}
                  activeDot={false}
                />*/}
                <Scatter type="natural" name="Actual" data={mainChartDataState} fill={theme.palette.primary.main} line shape="diamond" />
                <Line
                  type="natural"
                  dataKey="x"
                  stroke={theme.palette.warning.main}
                  strokeWidth={2}
                  dot={false}
                />
                </ComposedChart>
            </ResponsiveContainer>
          </Widget>
        </Grid>
        {/*{mock.bigStat.map(stat => (
          <Grid item md={4} sm={6} xs={12} key={stat.product}>
            <BigStat {...stat} />
          </Grid>
        ))}*/}
        <Grid item xs={12}>
          <Widget
            title="Loss summary"
            upperTitle
            noBodyPadding
            bodyClass={classes.tableWidget}
          >
            <SummaryTable data={summaryDataState} />
          </Widget>
        </Grid>
        <Grid item xs={12}>
          <Widget
            title="Quality Defects"
            upperTitle
            noBodyPadding
            bodyClass={classes.tableWidget}
          >
            <Table data={defectState} />
          </Widget>
        </Grid>
      </Grid>
    </>
  );
}

// #######################################################################
function getRandomData(length, min, max, multiplier = 10, maxDiff = 10) {
  var array = new Array(length).fill();
  let lastValue;

  return array.map((item, index) => {
    let randomValue = Math.floor(Math.random() * multiplier + 1);

    while (
      randomValue <= min ||
      randomValue >= max ||
      (lastValue && randomValue - lastValue > maxDiff)
    ) {
      randomValue = Math.floor(Math.random() * multiplier + 1);
    }

    lastValue = randomValue;

    return { value: randomValue };
  });
}

function getMainChartData() {
  
  var resultArray = [];
  var tablet = getRandomData(31, 1, 112, 10, 1);
  var desktop = getRandomData(31, 1, 112, 10, 5);
  var mobile = getRandomData(31, 1, 112, 10, 5);

  

  return resultArray;
}



function readIndexData(selectedDate, selectedShift, selectedLine){
  var lossArray = [];
  var ref = database.ref('ENS5/zone/' + selectedLine+'/Defect Data/' + selectedDate+'/'+selectedShift);
  ref.once('value', function(snapshot) {
    snapshot.forEach(function(childSnapshot) {
      var childKey = childSnapshot.key;
      var childData = childSnapshot.val();
      lossArray.push(childData);
    });
  });
  return lossArray;
  }
